import JncDialogTitle from '../modals/JncDialogTitle';
import { Dialog } from '@mui/material';
import PropTypes from 'prop-types';
import CopyButton from '../../../../../new-ui/components/common/CopyButton';

const BulkTransactionDetailModal = ({ close, open, data }) => {
    const fields = [
        { label: 'Account Id', value: data.accountId },
        { label: 'Type', value: data.type },
        { label: 'Currency Type', value: data.currencyType },
        { label: 'Currency', value: data.currency },
        { label: 'Amount', value: data.amount },
        { label: 'Beneficiary Account Number', value: data.beneficiaryAccountNumber },
        { label: 'Beneficiary Address', value: data.beneficiaryAddress },
        { label: 'Beneficiary Country', value: data.beneficiaryCountry },
        { label: 'Bank Name', value: data.bankName },
        { label: 'Bank Address', value: data.bankAddress },
        { label: 'Bank Country', value: data.bankCountry },
        { label: 'Sort Code', value: data.sortCode },
        { label: 'IBAN', value: data.iban },
        { label: 'Swift Code', value: data.swift },
        { label: 'Additional Info', value: data.additionalBankInfo },
        { label: 'Reference', value: data.reference },
    ];

    return (
        <Dialog
            fullScreen
            scroll={'paper'}
            onClose={close}
            open={open}
            className="jncModal bg-bulkpay-card-bg text-text">
            <JncDialogTitle
                topClassName={'bg-bulkpay-card-bg !text-text !-mb-1'}
                className="!font-inter text-xl font-semibold leading-loose tracking-tight pl-[14px] bg-bulkpay-card-bg uppercase !text-text"
                title={data.beneficiaryName}
                onClose={close}
                buttonCss="pr-[10px]"
                iconCss="text-[27px]"
            />
            <div className="lg:hidden block w-full text-text p-6 pt-3  bg-bulkpay-card-bg">
                {fields.map(field => (
                    <AccountDetailField key={field.label} label={field.label} value={field.value} />
                ))}
            </div>
        </Dialog>
    );
};

const AccountDetailField = ({ label, value, copyEnabled = true }) => {
    const displayValue = value || '-';

    return (
        <div className="pb-3 bg-bulkpay-card-bg text-text">
            <p
                className="text-balanceCard-manage text-sm font-medium leading-none uppercase mb-2"
                id={`field-${label.replace(/\s+/g, '-').toLowerCase()}`}>
                {label}:
            </p>
            <div className="jncTransactionModal__group-grid">
                <p
                    className="text-text uppercase text-sm leading-tight font-medium"
                    aria-labelledby={`field-${label.replace(/\s+/g, '-').toLowerCase()}`}>
                    {displayValue}
                </p>
                {copyEnabled && (
                    <CopyButton
                        className={'!fill-text'}
                        copyValue={displayValue}
                        aria-label={`Copy ${label}`}
                    />
                )}
            </div>
            <div className="self-stretch h-px mt-3 bg-input-border" />
        </div>
    );
};

AccountDetailField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    copyEnabled: PropTypes.bool,
};

BulkTransactionDetailModal.propTypes = {
    close: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    data: PropTypes.shape({
        accountId: PropTypes.string,
        type: PropTypes.string,
        currencyType: PropTypes.string,
        currency: PropTypes.string,
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        beneficiaryName: PropTypes.string,
        beneficiaryAddress: PropTypes.string,
        beneficiaryAccountNumber: PropTypes.string,
        beneficiaryCountry: PropTypes.string,
        bankName: PropTypes.string,
        bankAddress: PropTypes.string,
        bankCountry: PropTypes.string,
        sortCode: PropTypes.string,
        iban: PropTypes.string,
        swift: PropTypes.string,
        additionalBankInfo: PropTypes.string,
        reference: PropTypes.string,
    }),
};

export default BulkTransactionDetailModal;
